import BaseModel from "../base/baseModel";

export default class ContaPagarModel extends BaseModel {
    contaGerencialId = 0;
    dataVencimento: Date = null;
}
